<ion-header>
  <ion-toolbar>

    <ion-title>{{(action === 'add'? 'general.add' : 'general.edit') | translate}} {{'general.mealPlan' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" class="closeBtn ">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form class="formStyle2" #formData='ngForm' (ngSubmit)="onSubmit(formData)"
    [ngClass]="{'submitted': isFormSubmitted}">

    <ion-row>
      <ion-col>
        <ion-item class="ion-no-padding">
          <ion-label position="stacked">{{'general.title' | translate}}</ion-label>
          <ion-textarea 
            autoGrow class="formControl" type="text" 
            #title="ngModel" [(ngModel)]="mealPlan.title" name="title"
            maxlength="100"
            required>
              <span class="counter">{{getCounter(mealPlan.title, 100)}}</span>
          </ion-textarea>
        </ion-item>
        <div class="field-error" *ngIf="(isFormSubmitted || title.touched) && title.errors?.required">
          <span>{{'general.titleRequired' | translate}}</span>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="type === 'user'">
      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'general.start' | translate}}</ion-label>
          <div class="datepickerPanel">
            <input [owlDateTimeTrigger]="dtStart" [owlDateTime]="dtStart" #startDate="ngModel" name="startDate"
              class="formControl" [(ngModel)]="dates.start" required>
            <owl-date-time #dtStart [hour12Timer]="true" stepMinute="60"></owl-date-time>
          </div>
        </ion-item>
        <div class="field-error"
          *ngIf="(isFormSubmitted || startDate.touched) && startDate.errors?.required">
          <span>{{'general.start_date_required' | translate}}</span>
        </div>
      </ion-col>

      <ion-col size="6" *ngIf="!premium">
        <ion-item class="toggle">
          <ion-label position="stacked">{{'general.hideProg' | translate}}</ion-label>
          <ion-toggle name="startDateHidden" [disabled]="!dates.start" [(ngModel)]="mealPlan.startDateHidden"></ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="type === 'user'">
      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'general.end' | translate}}</ion-label>
          <div class="datepickerPanel">
            <input [owlDateTimeTrigger]="dtEnd" [owlDateTime]="dtEnd" #endDate="ngModel" name="endDate"
              class="formControl" [(ngModel)]="dates.end" (ngModelChange)="endDateChanged($event)">
            <owl-date-time #dtEnd [hour12Timer]="true" stepMinute="60" [startAt]="endPickerStartAt"></owl-date-time>
          </div>
        </ion-item>
      </ion-col>

      <ion-col size="6" *ngIf="!premium">
        <ion-item class="toggle">
          <ion-label position="stacked">{{'general.hideProdEnd' | translate}}</ion-label>
          <ion-toggle name="endDateHidden" [disabled]="!dates.end" [(ngModel)]="mealPlan.endDateHidden"></ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" color="secondary" (click)="formData.ngSubmit.emit()">
        {{'general.submit' | translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
